var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 32.4082,
    y2: -1,
    transform: "matrix(0.678841 0.734285 -0.678841 0.734285 2 1.9978)",
    stroke: "#389AF4",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 32.4082,
    y2: -1,
    transform: "matrix(0.678841 -0.734285 0.678841 0.734285 2 25.7947)",
    stroke: "#389AF4",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCross);
export default __webpack_public_path__ + "static/media/closeCross.15f79561aa884527d6c27ed7eb4e89ec.svg";
export { ForwardRef as ReactComponent };